import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useMemo, useState } from "react";
import getClassNameFactory from "../../utilities/classNames";
import { SearchInput } from "../../elements";
import debounce from "lodash/debounce";
import { getLocationSuggestionsWithId, formatSuggestedAddresses, getAddressErrorMessageFromCode } from "./LocationSuggestionsInput.utils";

var LocationSuggestionsInput = function LocationSuggestionsInput(props) {
  var name = props.name,
      value = props.value,
      typeahead = props.typeahead,
      placeholder = props.placeholder,
      onSubmit = props.onSubmit,
      fetchLocationSuggestions = props.fetchLocationSuggestions,
      errorMessage = props.errorMessage,
      autocomplete = props.autocomplete,
      label = props.label,
      handleError = props.handleError;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      locationSuggestionsWithId = _useState2[0],
      setLocationSuggestionsWithId = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      locationSuggestions = _useState4[0],
      setLocationSuggestions = _useState4[1];

  var getClassName = getClassNameFactory(LocationSuggestionsInput.displayName);
  var debounceTimeout = 500;
  var handleAddressLineSuggestionsChange = useMemo(function () {
    return debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(enteredValue) {
        var response, locationSuggestionsResponse, errorMessageFromCode, locationSuggestionsFromResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchLocationSuggestions(enteredValue);

              case 3:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                throw Error("Service returned error http status");

              case 6:
                _context.next = 8;
                return response.json();

              case 8:
                locationSuggestionsResponse = _context.sent;

                if (locationSuggestionsResponse) {
                  _context.next = 11;
                  break;
                }

                throw Error("Location suggestions data in the response is null");

              case 11:
                if (!locationSuggestionsResponse.addr_info_code.length) {
                  _context.next = 14;
                  break;
                }

                errorMessageFromCode = getAddressErrorMessageFromCode(locationSuggestionsResponse.addr_info_code);
                throw Error(errorMessageFromCode);

              case 14:
                formatSuggestedAddresses(locationSuggestionsResponse);
                locationSuggestionsFromResponse = getLocationSuggestionsWithId(locationSuggestionsResponse);
                setLocationSuggestionsWithId(locationSuggestionsFromResponse[0]);
                setLocationSuggestions(locationSuggestionsFromResponse[1]);
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](0);
                handleError(_context.t0);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 20]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), debounceTimeout);
  }, [fetchLocationSuggestions, handleError]);
  var handleAddressLineSuggestionsSubmit = useCallback(
  /*#__PURE__*/

  /* eslint-disable @typescript-eslint/no-explicit-any*/
  function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(selectedValue) {
      var locationWithId, response, locationSuggestionsResponse, errorMessageFromCode;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              locationWithId = locationSuggestionsWithId.find(function (location) {
                return location[selectedValue];
              });

              if (locationWithId) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              setLocationSuggestions([]);
              _context2.prev = 4;
              _context2.next = 7;
              return fetchLocationSuggestions(selectedValue, [locationWithId[selectedValue]]);

            case 7:
              response = _context2.sent;

              if (response.ok) {
                _context2.next = 10;
                break;
              }

              throw Error("Service returned error http status");

            case 10:
              _context2.next = 12;
              return response.json();

            case 12:
              locationSuggestionsResponse = _context2.sent;

              if (locationSuggestionsResponse) {
                _context2.next = 15;
                break;
              }

              throw Error("Location suggestions data in the response is null");

            case 15:
              if (!locationSuggestionsResponse.addr_info_code.length) {
                _context2.next = 18;
                break;
              }

              errorMessageFromCode = getAddressErrorMessageFromCode(locationSuggestionsResponse.addr_info_code);
              throw Error(errorMessageFromCode);

            case 18:
              onSubmit(selectedValue);
              _context2.next = 24;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](4);
              handleError(_context2.t0);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 21]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [locationSuggestionsWithId, fetchLocationSuggestions, onSubmit, handleError]);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, label, /*#__PURE__*/React.createElement(SearchInput, {
    name: name,
    value: value,
    searchSuggestions: locationSuggestions,
    autocomplete: autocomplete,
    onChange: handleAddressLineSuggestionsChange,
    onSubmit: handleAddressLineSuggestionsSubmit,
    hasError: Boolean(errorMessage),
    placeholder: placeholder,
    typeahead: typeahead
  }));
};

LocationSuggestionsInput.displayName = "LocationSuggestionsInput";
export default LocationSuggestionsInput;